import { Button } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

interface ChangePasswordButtonProps {
  hasEmail: boolean;
}

const ChangePasswordButton = observer((props: ChangePasswordButtonProps): React.JSX.Element | null => {
  const { hasEmail } = props;
  const {
    translateStore: { translate },
    passwordChangeStore,
  } = useStores();

  if (!hasEmail) {
    return null;
  }

  return (
    <Button
      onClick={() => {
        passwordChangeStore.resetPasswordForm();
        passwordChangeStore.handleChangePasswordModalOpen(true);
      }}
      size="small"
      text={translate('accountPage.changePw')}
      variant="secondary"
      attributes={{ type: 'submit' }}
    />
  );
});

export default ChangePasswordButton;
